module.exports = __webpack_public_path__ + "c43ebce2c720786f498726918f04ee55.pdf";